class Base {
	/**
	 * Genera una instancia de Base
	 * @param {string} alphabet
	 */
	constructor(alphabet) {
		this.alphabet = alphabet;
	}

	/**
	 * Returns an alphabet encoded represantation of a number
	 * @param {number} $num
	 * @param {string} $alphabet
	 * @returns {string}
	 */
	encode($num) {
		const $base_count = this.alphabet.length;
		let $encoded = "";
		while ($num >= $base_count) {
			const $div = $num / $base_count;
			const $mod = $num - $base_count * Math.trunc($div);
			$encoded = this.alphabet[$mod] + $encoded;
			$num = Math.trunc($div);
		}

		if ($num) $encoded = this.alphabet[$num] + $encoded;

		return $encoded;
	}

	/**
	 * Returns the decoded number from an alphabet encoded code
	 * @param {string} $code
	 * @param {string} $alphabet
	 * @returns {string}
	 */
	decode($code) {
		let $decoded = 0;
		let $multi = 1;
		while ($code.length > 0) {
			const $digit = $code[$code.length - 1];
			$decoded += $multi * this.alphabet.indexOf($digit);
			$multi = $multi * this.alphabet.length;
			$code = $code.substring(0, -1);
		}

		return $decoded;
	}

	/**
	 * Returns a random code with a given size
	 * @param {number} size
	 */
	random(size) {
		let str = "";
		for (let i = 0; i < size; i++) {
			const rand = Math.floor(Math.random() * 36);
			str += this.alphabet[rand];
		}

		return str;
	}
}

export class UID {
	static Base = new Base("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ");

	/**
	 * generates a UID
	 * @returns
	 */
	static getUID() {
		const base = this.Base.encode(Date.now());

		const rand = this.Base.random(4);

		return `${base}${rand}`;
	}
}